import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import BootstrapVue from 'bootstrap-vue'
import vbclass from 'vue-body-class'
import Toasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import VueAxios from 'vue-axios'
// import Tawk from 'vue-tawk'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import VueCryptojs from 'vue-cryptojs'

import {
    VueAuthenticateConfig,
    VeeValidateConfig,
    ToastedConfig,
} from '@/config'

import IdleVue from 'idle-vue'
const eventsHub = new Vue()

console.log = function () {}
console.warn = function () {}
console.error = function () {}
console.info = function () {}

// Disable debugger keyword
window.addEventListener('keydown', function (e) {
    if (e.key === 'F12') {
        e.preventDefault()
    }
})
document.addEventListener('contextmenu', (e) => e.preventDefault())

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: process.env.VUE_APP_TIME_OUT, // 10 mints,
    startAtIdle: false,
})

Vue.use(VueCryptojs)

// Load the full build.
window._ = require('lodash')

Vue.use(require('vue-moment'))
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, VueAuthenticateConfig)
Vue.use(VeeValidate, VeeValidateConfig)
Vue.use(Toasted, ToastedConfig)
Vue.use(BootstrapVue)
Vue.use(vbclass, router)
// Vue.use(Tawk, {
//     tawkSrc: 'https://embed.tawk.to/612f52c1649e0a0a5cd403fe/1fegdmh4q'
// })
Vue.config.productionTip = false
// Vue.config.devtools = true

require('@/auto-import.js')
require('@/route-middleware')
require('@/interceptor')
require('./filters')
require('./directives/authenticated-image')

window.httpRequest = Vue.prototype

new Vue({
    router: router,
    store,
    watch: {
        $route: function () {
            this.checkMeta()
            this.pageTop()
        },
    },
    methods: {
        checkMeta() {
            document.title =
                process.env.VUE_APP_TITLE + ' | ' + this.$route.meta.title
        },
        pageTop() {
            window.scrollTo(0, 0)
        },
    },
    render: (h) => h(App),
}).$mount('#app')
